import styled from "styled-components";

export const NoStyleButton = styled.button`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
`;
NoStyleButton.displayName = "NoStyleButton";
